<template>
  <div class="article-form">
    <div class="main-form">
      <a-row style="margin-bottom: 0">
        <a-tabs defaultActiveKey="1">
          <a-tab-pane tab="添加任务稿件" key="1">
            <a-row>
              <a-input
                defaultValue="mysite"
                size="large"
                v-model="article.title"
                placeholder="请输入标题"
              >
                <a-icon
                  slot="addonAfter"
                  type="edit"
                  :theme="showSubTitle ? 'filled' : 'outlined'"
                  @click="showSub"
                  style="cursor: pointer"
                />
              </a-input>
            </a-row>
            <a-row v-show="showSubTitle">
              <a-input placeholder="请输入副标题" v-model="article.subtitle" />
            </a-row>
            <a-row>
              <vue-html5-editor
                :content="article.content"
                style="min-height: 560px;"
                @change="updateData"
                ref="myeditor"
              ></vue-html5-editor>
            </a-row>
            <a-row>
              <span style="font-size: 14px;">关联任务：</span>
              <a-button
                type="danger"
                size="default"
                @click="chooseTask"
                v-if="!choosedTaskName"
              >
                选择任务<a-icon type="right" />
              </a-button>
              <a-tag
                closable
                @close="deleteTaskInfo"
                color="#1890ff"
                style="height: 32px;line-height: 32px;"
                v-else
                >{{ choosedTaskName }}</a-tag
              >
            </a-row>
            <a-row>
              <span style="font-size: 14px;">上传视频：</span>
              <a-button
                type="primary"
                size="default"
                @click="loadCloudVideo"
                v-if="!article.videoId"
              >
                从云视频选择
              </a-button>
              <a-tag
                closable
                @close="deleteVideoAttach"
                color="#1890ff"
                style="height: 32px;line-height: 32px;"
                v-else
                >{{ article.videoName }}</a-tag
              >
            </a-row>
          </a-tab-pane>
        </a-tabs>
      </a-row>
    </div>
    <!--<a-card :bordered="true" class="attr-form" hoverable style="min-height: 670px;">-->
    <!--<div style="padding: 10px">-->
    <!--&lt;!&ndash;<a-row justify="end" class="select-type" style="margin-bottom: 20px;">&ndash;&gt;-->
    <!--&lt;!&ndash;<a-col :span="24" class="title-pic">&ndash;&gt;-->
    <!--&lt;!&ndash;&ndash;&gt;-->
    <!--&lt;!&ndash;</a-col>&ndash;&gt;-->
    <!--&lt;!&ndash;</a-row>&ndash;&gt;-->
    <!--<a-row>-->
    <!--<a-upload-dragger-->
    <!--name="file"-->
    <!--action="//jsonplaceholder.typicode.com/posts/"-->
    <!--@change="handleChange"-->
    <!--&gt;-->
    <!--<p class="ant-upload-drag-icon" >-->
    <!--<a-icon type="inbox" />-->
    <!--</p>-->
    <!--<p class="ant-upload-text">点击上传视频</p>-->
    <!--</a-upload-dragger>-->
    <!--</a-row>-->
    <!--</div>-->
    <!--</a-card>-->

    <a-drawer
      title="云视频"
      placement="right"
      :closable="false"
      @close="onClose"
      width="330"
      :visible="cloudVideoVisible"
    >
      <div class="video-lists-main" style="z-index: 1002">
        <a-spin :spinning="videoSpinning">
          <div
            v-for="(item, index) in cloudVideoLists"
            class="video-lists"
            @click="selectVideo(item)"
            style="cursor: pointer;"
            :key="index"
          >
            <img :src="item.CoverURL" alt="" width="280px" height="180px" />
            <div
              style="text-align: center;height: 28px;line-height: 28px;overflow-x: hidden;white-space:nowrap;text-overflow: ellipsis;"
            >
              {{ item.Title }}
            </div>
          </div>
          <div style="padding: 5px;" v-if="!isLastVideo">
            <a-button type="dashed" block size="small" @click="getVideoLists"
              >加载更多...</a-button
            >
          </div>
        </a-spin>
      </div>
    </a-drawer>

    <footer-tool-bar>
      <!--<a-button type="danger" @click="deleteArticle" v-show="articleId">删除</a-button>-->
      <a-button type="primary" @click="handleSubmit">保存</a-button>
      <a-button @click="goBackToList">返回列表</a-button>
    </footer-tool-bar>
  </div>
</template>

<script>
import FooterToolBar from '../../components/FooterToolBar';

export default {
  name: 'AddArticle',
  components: {
    FooterToolBar
  },
  data() {
    return {
      userInfo: '',
      showSubTitle: false,
      fileList: [
        {
          uid: '-1',
          name: 'xxx.png',
          status: 'done',
          url:
            'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png'
        }
      ],
      article: {
        title: '',
        subtitle: '',
        content: '请输入内容',
        type: 1,
        videoId: '',
        videoName: '',
        videoPage: 1
      },
      choosedTaskId: '',
      choosedTaskName: '',
      articleId: '',
      cloudVideoVisible: false,
      cloudVideoLists: [],
      videoSpinning: true,
      isLastVideo: false
    };
  },
  methods: {
    deleteVideoAttach() {
      this.article.videoId = '';
      this.article.videoName = '';
    },
    selectVideo(item) {
      this.article.videoId = item.VideoId;
      this.article.videoName = item.Title;
      this.cloudVideoVisible = false;
    },
    getVideoLists() {
      this.$http
        .post('/api/AliyunVideo/VideoLists', {
          areaid: this.userInfo.area_id,
          deptid: this.userInfo.dept_id,
          page: this.article.videoPage,
          limit: 20
        })
        .then(res => {
          this.videoSpinning = false;
          if (res.data.state == 200) {
            for (let i in res.data.data) {
              res.data.data[i].CoverURL = res.data.data[i].CoverURL.replace(
                /fusion-media-wf.oss-cn-hangzhou.aliyuncs.com/,
                'wf.cdn.ycrmt.cn'
              );
              res.data.data[i].FileURL = res.data.data[i].FileURL.replace(
                /vod-media-wf.oss-cn-hangzhou.aliyuncs/,
                'wf.cdn.ycrmt.cn'
              );
              res.data.data[i].CoverURL;
              this.cloudVideoLists.push(res.data.data[i]);
            }
            if (res.data.data.length >= 20) {
              this.article.videoPage++;
            } else {
              this.isLastVideo = true;
            }
          } else if (res.data.state == 400) {
            this.cloudVideoVisible = false;
            this.isLastVideo = true;
          }
        });
    },
    onClose() {
      this.cloudVideoVisible = false;
    },
    loadCloudVideo() {
      this.cloudVideoVisible = true;
      this.article.videoPage = 1;
      this.isLastVideo = false;
      this.videoSpinning = true;
      this.cloudVideoLists = [];
      this.getVideoLists();
    },
    updateData(content) {
      this.article.content = content;
    },
    handleSubmit() {
      if (!this.article.title) {
        this.$message.error('请输入标题');
        return;
      }
      if (this.article.content === '请输入内容' || !this.article.content) {
        this.$message.error('请输入内容');
        return;
      }
      if (!this.choosedTaskId) {
        this.$message.error('请选择任务');
        return;
      }
      var postData = {
        id: this.articleId,
        title: this.article.title,
        subtitle: this.article.subtitle,
        content: this.article.content,
        type: this.article.type,
        task_id: this.choosedTaskId,
        dept_id: this.userInfo.dept_id,
        user_id: this.userInfo.userid,
        attach: this.article.videoId,
        adduser: this.userInfo.truename
      };
      this.$http
        .post('api/article/update', postData)
        .then(res => {
          if (res.data.state === 200) {
            // 发布成功 全部置空
            this.$store.commit('storeAddArticleInfo', {
              title: '',
              subtitle: '',
              content: '请输入内容',
              type: 1,
              videoId: '',
              videoName: ''
            });
            this.$store.commit('storeChoosedTaskInfo', { id: '', name: '' });
            this.article.title = '';
            this.article.subtitle = '';
            this.article.content = '';
            this.article.type = 1;
            this.choosedTaskId = '';
            this.choosedTaskName = '';
            this.article.videoId = '';
            this.article.videoName = '';
            if (this.articleId) {
              this.$message.success('修改成功');
              setTimeout(() => {
                this.$router.push('/Main/Draft/ArticleList');
              }, 2000);
            } else {
              this.$message.success('发布成功');
              setTimeout(() => {
                this.$router.push('/Main/Draft/ArticleList');
              }, 2000);
            }
          }
        })
        .catch(() => {});
    },
    showSub() {
      this.showSubTitle = !this.showSubTitle;
    },
    handleChange(info) {
      const status = info.file.status;
      if (status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (status === 'done') {
        this.$message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === 'error') {
        this.$message.error(`${info.file.name} file upload failed.`);
      }
    },
    chooseTask() {
      this.$store.commit('storeAddArticleInfo', {
        title: this.article.title,
        subtitle: this.article.subtitle,
        content: this.article.content,
        type: this.article.type,
        videoId: this.article.videoId,
        videoName: this.article.videoName
      });
      // this.$store.commit('storeIsSelectingTaskAction', true)
      this.$store.commit('storeIsSelectingProgressAction', true);
      this.$router.push('/Main/Task/TaskProgressList');
    },
    deleteTaskInfo() {
      this.choosedTaskId = '';
      this.choosedTaskName = '';
      // this.$store.commit('storeChoosedTaskInfo', {id: '', name: ''})
    },
    goBackToList() {
      this.$store.commit('storeAddArticleInfo', {
        title: '',
        subtitle: '',
        content: '请输入内容',
        type: 1,
        videoId: '',
        videoName: ''
      });
      this.$store.commit('storeChoosedTaskInfo', { id: '', name: '' });
      this.$router.push('/Main/Draft/ArticleList');
    },
    deleteArticle() {
      const that = this;
      this.$confirm({
        title: '确定删除该稿件?',
        content: '',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        centered: true,
        onOk() {
          that.deleting();
        },
        onCancel() {}
      });
    },
    deleting() {
      this.$http
        .post('api/article/delete', { ids: this.articleId })
        .then(res => {
          if (res.data.state === 200) {
            this.$message.success('已删除');
            setTimeout(() => {
              this.$router.go(-1);
            }, 2000);
          }
        })
        .catch(() => {});
    }
  },
  created() {
    this.userInfo = JSON.parse(localStorage.getItem('siteinfo'));
  },
  mounted() {
    this.choosedTaskId = this.$store.state.choosedTaskInfo.id;
    if (this.$store.state.choosedTaskInfo.name) {
      this.choosedTaskName = this.$commonFunction.mySubStr(
        this.$store.state.choosedTaskInfo.name,
        26
      );
    } else {
      this.choosedTaskName = '';
    }
    this.article.title = this.$store.state.choosedArticleInfo.title;
    this.article.subtitle = this.$store.state.choosedArticleInfo.subtitle;
    this.article.content = this.$store.state.choosedArticleInfo.content;
    this.article.type = this.$store.state.choosedArticleInfo.type;
    this.article.videoId = this.$store.state.choosedArticleInfo.videoId;
    this.article.videoName = this.$store.state.choosedArticleInfo.videoName;

    if (this.article.subtitle) {
      this.showSubTitle = true;
    } else {
      this.showSubTitle = false;
    }

    // 获取文章详情
    if (this.$route.query.id) {
      this.articleId = this.$route.query.id;
      if (!this.$store.state.choosedArticleInfo.title) {
        this.$http
          .post('api/article/detail', { id: this.articleId })
          .then(res => {
            if (res.data.state === 200) {
              this.article.title = res.data.data.title;
              this.article.subtitle = res.data.data.subtitle;
              this.article.content = res.data.data.content;
              this.choosedTaskId = res.data.data.task_id;
              this.choosedTaskName = this.$commonFunction.mySubStr(
                res.data.data.tasktitle,
                60
              );
              this.article.videoId = res.data.data.attach;
              this.article.videoName =
                '已上传视频，视频ID为：' + this.article.videoId;
              this.article.type = res.data.data.type;
              if (this.article.subtitle) {
                this.showSubTitle = true;
              } else {
                this.showSubTitle = false;
              }
              // this.$store.commit('storeAddArticleInfo', {title: this.article.title, subtitle: this.article.subtitle, content: this.article.content, type: this.article.type, videoId: this.article.videoId})
              this.$store.commit('storeChoosedTaskInfo', {
                id: this.choosedTaskId,
                name: this.choosedTaskName
              });
            }
          })
          .catch(() => {});
      } else {
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {});
  },
  beforeRouteLeave(to, from, next) {
    if (
      from.path.indexOf('AddArticle') > -1 &&
      to.path.indexOf('ArticleList') > -1
    ) {
      this.$store.commit('storeAddArticleInfo', {
        title: '',
        subtitle: '',
        content: '请输入内容',
        type: 1,
        videoId: '',
        videoName: ''
      });
      this.$store.commit('storeChoosedTaskInfo', { id: '', name: '' });
    }
    next();
  }
};
</script>

<style scoped>
.main-form {
  position: absolute;
  top: 20px;
  right: 330px;
  bottom: 70px;
  left: 20px;
}
.attr-form {
  overflow-y: auto;
  position: absolute;
  width: 300px;
  top: 20px;
  right: 10px;
}

.article-form {
  top: 42px;
  left: 0;
  right: 0px;
  bottom: 56px;
  background-color: #fff;
  position: absolute;
  overflow-y: auto;
}
.select-type {
  height: 40px;
  line-height: 40px;
  text-align: right;
  font-size: 16px;
  margin-top: 5px;
}
.select-type button {
  margin-right: 5px;
}
.title-pic {
  text-align: left;
  padding-left: 10px;
  padding-top: 3px;
}
.ant-upload-drag-icon {
  margin: 20px 0;
}

.ant-row {
  line-height: 40px;
  margin-bottom: 10px;
}

.checked {
  font-size: 10px;
  padding-top: 7px;
}
.active {
  color: #fff;
  background-color: rgba(82, 196, 26, 0.8);
}
</style>
